import React, {Component} from 'react'
import LgaMap from './lga-map'

// Component to fix beforeChange bug rerendering slick
class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{ this.props.children }</>)
  }
}

const SuburbMap = (props) => {
  return (
    <section className='suburb-map' id="location">
      <div className='suburb-map__inner'>
        <BlockUpdate>
          <LgaMap {...props}  />
        </BlockUpdate>
      </div>
    </section>
  )
}

export default SuburbMap
